import { useTranslation } from 'gatsby-plugin-react-i18next';
import { getImage, ImageDataLike } from 'gatsby-plugin-image';

import Link from '../Atoms/Link';

import { ImageGatsby } from '../Atoms/Image';
import { FlyInText } from '../Atoms/Animations';
import ArrowButton from '../Atoms/ArrowButton';
import PaymentGuaranteed from '../Atoms/Icons/PaymentGuaranteed';

type TextImageProps = {
  title: string,
  subtitle: string,
  image: ImageDataLike,
  description?: string,
  url?: string,
  cta?: string,
  textWrapperClass?: string,
  titleClass?: string,
  imgClass?: string,
  isImageRight?: boolean,
  isTextPrimary?: boolean,
  withTrustLogo?: boolean,
};


const TextImage = ({
  title,
  subtitle,
  image,
  description,
  url = '',
  cta = '',
  imgClass = "flex-shrink-0 flex xl:w-1/2",
  textWrapperClass = "py-10 w-5/10",
  titleClass = '',
  isImageRight = true,
  isTextPrimary = true,
  withTrustLogo = true,
}: TextImageProps) => {
  const { t } = useTranslation();

  const graphqlImage = getImage(image);

  return (
    <section className="lg:py-12 px-4 lg:px-8">
      <div className="max-w-screen-2xl w-full mx-auto flex flex-row relative">
        {isImageRight && <div className="lg:w-1/12 lg:block hidden" />}
        <div className={`w-full lg:w-10/12 flex flex-col ${isImageRight ? 'lg:flex-row' : 'lg:flex-row-reverse lg:pr-10'}`}>
          <div className={textWrapperClass}>
            {subtitle && <FlyInText tag='p' className="font-cirka mb-5 w-1/2">{t(subtitle)}</FlyInText>}
            <FlyInText tag='h2' y='40px' className={`${isTextPrimary && 'text-primary'} font-cirka text-4xl lg:text-5xl mb-16 ${titleClass}`}>{t(title)}</FlyInText>
            <FlyInText tag='p' y='80px' className="font-light mb-16" dangerouslySetInnerHTML={{ __html: t(description) }} />
            {url && <Link to={t(url)} className="text-primary font-roboto font-light flex items-center no-animation">
              <ArrowButton isGhost={false} className="mr-4" />
              {t(cta)}
            </Link>}
          </div>
          <div className="lg:w-1/5 lg:block hidden" />
          <div className={imgClass}>
            <div className="w-64 lg:w-full">
              <ImageGatsby alt={title} image={graphqlImage} />
            </div>
            {withTrustLogo &&
              <PaymentGuaranteed className="w-18 block lg:hidden static ml-6" />
            }
          </div>
        </div>
        {withTrustLogo &&
          <PaymentGuaranteed className="lg:w-1/12 hidden lg:block absolute lg:static bottom-64 right-28 lg:ml-4" />
        }
      </div>
    </section>
  );
}

export default TextImage;
